const dadosSistemaGridConfig = {
  idField: "id",
  columns: [
    { header: "Nome", field: "NOME_RESPONSAVEL" },
    { header: "CPF/CNPJ", field: "CPF_CNPJ" },
    { header: "E-mail", field: "EMAIL1" }, 
    { header: "Telefone", field: "TELEFONE1" }
  ]
};

export default dadosSistemaGridConfig